import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Import default CSS for Toastify
import "./CustomToastStyles.css"; // Import custom styles
import Header from "./Header.js";
import useAuth from './useAuth';
import Sidebar from "./Sidebar.js";
import Footer from "./Footer.js";


function Add_Vehiclenumber() {
    useAuth();
    const [formData, setFormData] = useState({
        vehicle_number: "",
        vehicle_modal: "",
        vehicle_type: "",
        fuel_type: "",
        fuel_unit: "",

    });
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const API_BASE_URL1 = process.env.REACT_APP_API_BASE_URL1;
    const token = localStorage.getItem('authToken');
    const navigate = useNavigate();
    const [vehicleModals, setVehicleModals] = useState([]);
    const [vehicleTypes, setVehicleTypes] = useState([]);
    const [fuelTypes, setFuelTypes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const validateFormData = () => {
        const { vehicle_number } = formData;
        if (!vehicle_number) {
            toast.error("All fields are required");
            return false;
        }
        return true;
    };

    // fetch vehicle modals
    const fetchVehicleModals = async (id) => {
        try {
            const response = await fetch(`${API_BASE_URL}getVehicleModels`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status) {
                setVehicleModals(result.data);
            } else {
                setError(result.message);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setError('Failed to fetch items');
        } finally {
            setLoading(false);
        }
    };

    // fetch vehicle types
    const fetchVehicleTypes = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}getVehicleTypes`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status) {
                setVehicleTypes(result.data);
            } else {
                setError(result.message);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setError('Failed to fetch items');
        } finally {
            setLoading(false);
        }
    };

    // fetch fuel types
    const fetchFuelTypes = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}getFuelTypes`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status) {
                setFuelTypes(result.data);
            } else {
                setError(result.message);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setError('Failed to fetch items');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchVehicleTypes();
        fetchVehicleModals();
        fetchFuelTypes();
    }, [navigate]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateFormData()) return;

        const formDataToSubmit = new FormData();
        Object.keys(formData).forEach((key) => {
            if (formData[key] !== null && formData[key] !== "") {
                formDataToSubmit.append(key, formData[key]);
            }
        });

        try {
            const token = localStorage.getItem("authToken");
            const response = await fetch(`${API_BASE_URL}addVehicleNumber`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    // No 'Content-Type' header for FormData
                },
                body: formDataToSubmit,
            });

            const result = await response.json();

            if (result.status) {
                toast.success("Vehicle Number successfully added");
                setFormData({
                    vehicle_number: "", // Reset the state name
                });
                navigate("/manage_vehiclenumber"); // Navigate to manage states instead of branches
            } else {
                toast.error(result.message || "An error occurred while adding the state.");
            }
        } catch (error) {
            console.error("Fetch error:", error);
            toast.error("Failed to submit form");
        }
    };


    return (
        <div className='hold-transition sidebar-mini layout-fixed'>
            <div className='wrapper'>
                <Header />
                <Sidebar />

                <div className='content-wrapper'>
                    <div className='content-header'>
                        <div className='container-fluid'>
                            <div className='row mb-2'>
                                <div className='col-sm-6'>
                                    <h1 className='m-0'>Add Vehicle Number</h1>
                                </div>
                                <div className='col-sm-6'>
                                    <ol className='breadcrumb float-sm-right'>
                                        <li className='breadcrumb-item'>
                                            <a href='#'>Home</a>
                                        </li>
                                        <li className='breadcrumb-item active'>Add Vehicle Number</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className='col-lg-12'>
                        <div className='card' style={{ borderTop: "3px solid #00c0ef" }}>
                            <div className='box box-info'>
                                <div className='card-body'>
                                    <form onSubmit={handleSubmit} method='post' acceptCharset='utf-8'>
                                        <div className='box-body'>
                                            <div className='row'>
                                                <div className='col-md-12 row'>
                                                    <div className='form-group col-sm-2'>
                                                        <label htmlFor='name'>
                                                            Vehicle Number <span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <input
                                                            type='text'
                                                            name='vehicle_number'
                                                            id='vehicle_number'

                                                            value={formData.vehicle_number} // Correctly referencefuel_type
                                                            onChange={handleChange}
                                                            className='form-control form-control-sm mt-1'
                                                            placeholder='Vehicle Number'
                                                        />
                                                    </div>
                                                    <div className='form-group col-sm-4'>
                                                        <label htmlFor='name'>
                                                            Vehicle Model <span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <select 
                                                        className="form-control form-control-sm mt-1"
                                                        onChange={handleChange}
                                                         name='vehicle_modal'
                                                          id='vehicle_modal'>
                                                            <option value="">Vehicle Model</option>
                                                            {vehicleModals.map((vehicleModal) => (
                                                                <option key={vehicleModal.id} value={vehicleModal.vehicle_modal}>
                                                                    {vehicleModal.vehicle_modal}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    <div className='form-group col-sm-2'>
                                                        <label htmlFor='name'>
                                                            Vehicle Type <span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <select onChange={handleChange} className="form-control form-control-sm mt-1" name='vehicle_type' id='vehicle_type'>
                                                            <option value="">Vehicle Type</option>
                                                            {vehicleTypes.map((vehicleType) => (
                                                                <option key={vehicleType.id} value={vehicleType.vehicle_type}>
                                                                    {vehicleType.vehicle_type}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>


                                                    <div className='form-group col-sm-2'>
                                                        <label htmlFor='name'>
                                                            Fuel Type <span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <select onChange={handleChange} className="form-control form-control-sm mt-1" name='fuel_type' id='fuel_type'>
                                                            <option value="">Fuel Type</option>
                                                            {fuelTypes.map((fuelType) => (
                                                                <option key={fuelType.id} value={fuelType.fuel_type}>
                                                                    {fuelType.fuel_type}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    <div className='form-group col-sm-2'>
                                                        <label htmlFor='name'>
                                                            Fuel Unit <span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <select onChange={handleChange} className="form-control form-control-sm mt-1" name='fuel_type' id='fuel_type'>
                                                            <option value="">Fuel Unit</option>
                                                            <option value='Litre'>Litre</option>
                                                            <option value='Kg'>Kg</option>
                                                            <option value='Electricity'>Electricity</option>
                                                        </select>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                        <div className='box-footer'>
                                            <button type='submit' className='btn btn-success pull-right'>
                                                Submit
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                <Footer />

                <aside className='control-sidebar control-sidebar-dark'></aside>
            </div>

            {/* Toast Container */}
            <ToastContainer />
        </div>
    )
}

export default Add_Vehiclenumber